import { render, staticRenderFns } from "./deleteMenuUser.vue?vue&type=template&id=5df1a294&scoped=true"
import script from "./deleteMenuUser.vue?vue&type=script&lang=js"
export * from "./deleteMenuUser.vue?vue&type=script&lang=js"
import style0 from "./deleteMenuUser.vue?vue&type=style&index=0&id=5df1a294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df1a294",
  null
  
)

export default component.exports